import { MenuItem, Paper } from '@mui/material';
import { Radio } from '@village/ui';
import { rem } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgb(26, 26, 26);
    border-top-color: rgb(26, 26, 26);
    border-right-color: rgb(26, 26, 26);
    border-left-color: rgb(26, 26, 26);
    height: ${rem(80)};
    padding: ${rem(16)};
    position: sticky;
    background: white;
    top: 0;
    z-index: 1;
    box-shadow:
        0 2px 1px -1px rgba(0, 0, 0, 0.2),
        0 1px 1px rgba(0, 0, 0, 0.14),
        0 1px 3px rgba(0, 0, 0, 0.12);
`;

export const Logo = styled.img`
    max-height: ${rem(48)};
    max-width: ${rem(160)};
`;

export const LanguagePaper = styled(Paper)`
    width: ${rem(162)};
    border-radius: ${rem(16)};
`;

export const LanguageMenuItem = styled(MenuItem)`
    padding: ${rem(6)} ${rem(16)};
`;

export const LanguageRadio = styled(Radio)`
    .MuiFormControlLabel-label {
        font-family: CeraProRegular, arial, sans-serif;
    }

    .MuiButtonBase-root {
        padding: ${rem(9)};
        color: ${({ theme }) => theme.vui.colors.icon.default};
    }
`;
